class FacebookIntegratedAdAccount {
  public readonly id: FacebookAdAccountId;
  public readonly accountId: string;
  public readonly name: string;
  public readonly myRole: MyRole;

  constructor({
    id,
    accountId,
    name,
    myRole,
  }: {
    id: FacebookAdAccountId;
    accountId: string;
    name: string;
    myRole: MyRole;
  }) {
    this.id = id;
    this.accountId = accountId;
    this.name = name;
    this.myRole = myRole;
  }

  public static fromJSON = (json: any): FacebookIntegratedAdAccount => {
    const obj = { ...json };
    const { id, accountId, name, myRole } = obj;
    if (typeof id !== 'string') {
      throw new Error('.id must be a string');
    }
    if (typeof accountId !== 'string') throw new Error('.accountId must be a string');
    if (typeof name !== 'string') throw new Error('.name must be a string');
    if (Object.keys(MyRole).indexOf(myRole) === -1) throw new Error('.myRole must be any one of project state');
    return new FacebookIntegratedAdAccount({
      id,
      accountId,
      name,
      myRole,
    });
  };
}

export type FacebookAdAccountId = string;
export type MyRole = 'ADMIN' | 'GENERAL_USER' | 'REPORTS_ONLY';
export const MyRole: Record<MyRole, MyRole> = {
  ADMIN: 'ADMIN',
  GENERAL_USER: 'GENERAL_USER',
  REPORTS_ONLY: 'REPORTS_ONLY',
};

export default FacebookIntegratedAdAccount;
